import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../core';
import Heading from '../Heading';
import Icon from '../Icon';

export interface CardProps {
  backgroundColor?: string;
  title?: string;
  children: React.ReactNode;
  contentPadding?: string;
  onClick?: () => void;
  iconType?: string;
}

const Wrapper = styled.div<CardProps>`
  ${({ backgroundColor }) =>
    backgroundColor
      ? `background-color: ${backgroundColor};`
      : `background-color: ${colors.white};`}
  border: 1px solid ${colors.smoke};
  border-radius: 3px;
  display: block;
  margin-bottom: 16px;

  & > *:last-child {
    margin-bottom: 0;
  }
`;

const Title = styled.div<CardProps>`
  background-color: ${colors.pearl};
  padding: 16px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const Content = styled.div<CardProps>`
  padding: ${({ contentPadding }) => (contentPadding ? contentPadding : '16px')};
`;

const Card = ({
  backgroundColor,
  title,
  contentPadding,
  onClick,
  iconType,
  children,
}: CardProps) => {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      {title ? (
        <Title>
          <Heading size={5} noMargin>
            {title}
          </Heading>
          {iconType ? (
            <Icon type={iconType} size={24} onClick={onClick} color={colors.primary} />
          ) : null}
        </Title>
      ) : null}
      <Content contentPadding={contentPadding}>{children}</Content>
    </Wrapper>
  );
};

export default Card;
